
var old_product_img_html = '';
// if sandbox replace the url with https://tuvd1ov9o6.execute-api.us-west-1.amazonaws.com/customizer/customizer-sandbox

var printer_order_number_label_exist = typeof(customizer_printer_settings) == 'object' && customizer_printer_settings.hasOwnProperty('order_number_label_exist') && customizer_printer_settings['order_number_label_exist'] == '1' ? true : false;

// console.log("customizer_printer_settings", customizer_printer_settings);
// console.log("printer_order_number_label_exist", printer_order_number_label_exist);

for (var customizer_settings_key in customizer_settings) {

  if (customizer_settings.hasOwnProperty(customizer_settings_key)) {

    var append_key = "" == query_string ? '' : '&';

    query_string +=
      append_key +
      customizer_settings_key +
      "=" +
      encodeURIComponent(customizer_settings[customizer_settings_key]);
  }

}



document.getElementById("customized-image").src = customizer_settings.img_url;
window.customized_url = customizer_base_url + query_string;

var printer_query_string = "";

var keys_array = ['angle', 'img_url'];

for (var customizer_printer_settings_key in customizer_printer_settings) {
  if (customizer_printer_settings_key != 'img_url' && customizer_printer_settings.hasOwnProperty(customizer_printer_settings_key) && (customizer_printer_settings_key.indexOf("order_number") < 0)) {

    var customizer_printer_settings_val = customizer_printer_settings[customizer_printer_settings_key];

    var append_key = "" == printer_query_string ? '' : '&';

    if (printer_order_number_label_exist && !keys_array.includes(customizer_printer_settings_key)) {

      if (customizer_printer_settings.hasOwnProperty("order_number_" + customizer_printer_settings_key)) {
        customizer_printer_settings_val += "__" + customizer_printer_settings["order_number_" + customizer_printer_settings_key];
      } else {
        customizer_printer_settings_val += "__" + customizer_printer_settings_val.split("__").pop();
      }
    }
    printer_query_string += append_key +
      customizer_printer_settings_key +
      "=" +
      customizer_printer_settings_val;
  }
}

window.printer_customized_url = customizer_base_url + printer_query_string;
var i = 0,
  input_customize_text = [];

for (i = 1; i <= total_fields; i++) {
  var current_field = document.getElementById("customize-text-" + i);

  if ("yes" == force_caps) {
    current_field.style["text-transform"] = "uppercase";
  } else if ("yes" == force_lower_caps) {
    current_field.style["text-transform"] = "lowercase";
  }

  current_field.addEventListener("input", updateCustomizedImage);
}

if (document.getElementById('customize-heart')) {
  document.getElementById('customize-heart').addEventListener("input", updateCustomizedImage);
}

var slides = document.getElementsByClassName("block-swatch__radio");
for (var i = 0; i < slides.length; i++) {
  var ele = slides.item(i);
  if (i == 0) {
    ele.click();
  }
}



function updateCustomizedImage(e = '') {
  window.printer_final_customized_url = "";
  var all_empty = true;
  var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  var special_char_el = document.getElementById("special-char-message");
  var t = "";
  for (i = 1; i <= total_fields; i++) {
    var k = i - 1;
    var input_val = document.getElementById("customize-text-" + i).value;

    if (input_val.match(regex)) {

      document.getElementById("customize-text-" + i).value = input_val.replace(regex, '');
      special_char_el.style.display = "block";
      special_char_el.textContent = "Some of the characters you entered are not supported and have been removed.";
      setTimeout(function() {
        special_char_el.style.display = "none";
      }, 5000);
    }
    input_val = document.getElementById("customize-text-" + i).value;

    if (input_val) {
      all_empty = false;
    }
    t = i == 1 ? input_val : t + "__" + input_val;
    if (force_caps == "yes") {

      customized_words[k] = input_val.toUpperCase();
      t = t.toUpperCase();
    } else if (force_lower_caps == "yes") {

      customized_words[k] = input_val.toLowerCase();
      t = t.toLowerCase();
    } else {
      customized_words[k] = input_val;
    }
  }

  if (document.getElementById('customize-heart')) {
    if (document.getElementById('customize-heart').checked) {
      customized_words[total_fields] = document.getElementById('customize-heart').value;
      t += '__' + document.getElementById('customize-heart').value;
      all_empty = false;
    } else {
      customized_words[total_fields] = '';
      customized_words.pop();
    }
  }

  if (all_empty) {
    document.getElementById("customized-image").src = customizer_settings.img_url;
    return;
  }

  image_url = window.customized_url + "&words=" + btoa(unescape(encodeURIComponent(t.replace('__~heart~', ''))));

if (document.querySelector('input[name="color-selected"]')) {
  var replaceWith = document.querySelector( 'input[name="color-selected"]:checked').value;
    // console.log("before"+image_url);
  // image_url = image_url.replace(/221210/gi, replaceWith);
  //   console.log(image_url);
  
  var regex_color = /(font_color=[^&]*)/g;
  
  // Use replace() with a callback function to replace the font_color value
   image_url = image_url.replace(regex_color, function(match) {
    return match.replace(/([A-Za-z0-9]{6})/g, replaceWith);
  });

}


  if (printer_order_number_label_exist) {

    var order_label = "order_number";

    if (customizer_printer_settings.hasOwnProperty('order_number_prefix')) {
      order_label = customizer_printer_settings['order_number_prefix'] + order_label;
    }

    if (customizer_printer_settings.hasOwnProperty('order_number_suffix')) {
      order_label = order_label + customizer_printer_settings['order_number_suffix'];
    }

    var t_printer = t + "__" + order_label;
  } else {
    var t_printer = t;
  }

  t_printer = t_printer.replace('♥', '');

  console.log('t_printer', t_printer);

  window.printer_final_customized_url = window.printer_customized_url + "&words=" + btoa(unescape(encodeURIComponent(t_printer)));
  document.getElementById("customized-image").src = image_url;

  var s = setInterval(function() {
    var e = document.getElementById("customized-image");
    e.complete && 0 !== e.naturalHeight ?
      (clearInterval(s),
        (document.getElementById("image-loader").style.display = "none")) :
      (document.getElementById("image-loader").style.display = "inline-block");
  }, 1e3);
}


function saveCustomization(customized_words_input = '') {

  // Check for terms checkbox (only exists on some products like Family Portrait)
  // Must add null check to prevent breaking customizer on regular products
  const checkbox = document.getElementById('terms-checkbox-custom-text');

  if (checkbox && !checkbox.checked) {
    alert('Please confirm spelling and approve the terms before adding to cart.');
    return;
  }

  // Close modal after validation passes
  document.dispatchEvent(
    new CustomEvent('modal:close')
  );


  if (customized_words_input) {
    customized_words = customized_words_input;

    image_url = window.customized_url + "&words=" + btoa(unescape(encodeURIComponent(customized_words.join('__'))));

  } else {
    image_url = document.getElementById("customized-image").src;
  }

  if (!customized_words.join('').length) {
    // Submitted blank fields.
    const lb_button = document.querySelector('.block-swatch__radio[value="Leave Blank"]');
    if (lb_button) {
      lb_button.checked = true;
    }

    const ne_button = document.querySelector('.block-swatch__radio[value="No Embroidery"]');
    if (ne_button) {
      ne_button.checked = true;
    }

    resetCustomization();
    return;
  }
  else {

    const lb_button_custom = document.querySelector('.block-swatch__radio[value="Add Custom Text"]');
    console.log("helloamit");
    console.log(lb_button_custom);
    
    if (lb_button_custom) {
      lb_button_custom.checked = true;
    }
    
  }

  if (window.printer_final_customized_url) {
    for (var i = 0; i < printer_img_urls.length; i++) {
      var final_printer_url = window.printer_final_customized_url + "&img_url=" + printer_img_urls[i];
      console.log("Printer URL", i, final_printer_url);
     console.log("Dropbox Printer TEST URL ", i, final_printer_url+"&file_path=L0Fwb2xpcy9UZXN0LUFydHdvcmsvdGVzdGFwb2xpcy5wbmc=");
        
    }
  }

  document.getElementById("customize-modal-element").textContent = "Edit";
  document.getElementById("customized-text").textContent = "Your text: " + customized_words.join("  ").replace('~heart~', '♥');
  var customized_words_val = customized_words.join(" | ").replace(' ♥', '♥').replace('♥', ' | ~heart~');
  var customized_words_cart_item = "Your text: " + customized_words_val; //.replace(' | ~heart~', ' | heart');
  window.final_customized_pdp_url = window.location.href + (window.location.href.indexOf('?') === -1 ? '?' : '&') + "customization_text=" + encodeURIComponent(customized_words_val);

  document.getElementById("customized-words").value = customized_words_cart_item;

  console.log('customized_words', customized_words, customized_words_cart_item);

  localStorage.setItem("cart-item-link-" + meta.product.id + "-" + btoa(unescape(encodeURIComponent(customized_words_cart_item))), image_url);

  var edit_block = document.getElementById("edit-customization-block");
  edit_block.style["display"] =
    "block";

  if(is_v2) {
    var v2Element = document.getElementById('v2-customized');
    v2Element.value = 'yes';
    markSelectedSwatchByTag("add-custom-text");
  }

  var img_elements = document.getElementsByClassName('product-gallery__image');
  var img_element = img_elements[0];
  if (old_product_img_html == '') {
    old_product_img_html = img_element.parentElement.innerHTML;
  }
  img_element.parentElement.innerHTML = '<img data-action="open-modal" aria-controls="modal-customize-product" class="product-gallery__image" src="' + image_url + '" />';

  // Gift-tag multi-variant customizer products only (flag emitted by product-info.liquid,
  // gated on 'Gift Tag' + variants.size>1). The customer picks a leather color/finish, which
  // scrolls the Flickity gallery to that variant's featured cell (pos 1/8/9/12/13) — so the
  // cell-0 swap above lands on a HIDDEN slide and the render never appears. Additively paint
  // the currently-selected carousel cell too, so the personalized render shows on the color
  // they're viewing. Scope-guarded: this block is skipped entirely for every non-gift-tag
  // product, leaving their behavior byte-identical. Falls back to no-op if no cell is selected.
  if (window.__giftTagGallerySwap) {
    var __selCell = document.querySelector('.product-gallery__carousel-item.is-selected');
    var __selImg = __selCell ? __selCell.querySelector('.product-gallery__image') : null;
    if (__selImg && __selImg.parentElement) {
      __selImg.parentElement.innerHTML = '<img data-action="open-modal" aria-controls="modal-customize-product" class="product-gallery__image" src="' + image_url + '" />';
    }
  }

//   var img_elements = document.getElementsByClassName('product-gallery__thumbnail');
//   var img_element = img_elements[0];

//   img_element.click();

document.querySelector('.product-form__add-button')?.click();
  
}

function build_base_url(params) {
  for (var customizer_settings_key in params) {
  var query_string = "";
    if (params.hasOwnProperty(customizer_settings_key)) {

      var append_key = "" == query_string ? '' : '&';

      query_string +=
        append_key +
        customizer_settings_key +
        "=" +
        encodeURIComponent(params[customizer_settings_key]);
    }

  }
  
  return customizer_base_url + query_string;

}

function get_customizer_printer_url(tag) {
  var printer_query_string = "";

  var customizer_printer_settings = customizer_fields[tag].customizer_printer;

  var printer_order_number_label_exist =
    typeof customizer_printer_settings == "object" &&
    customizer_printer_settings.hasOwnProperty("order_number_label_exist") &&
    customizer_printer_settings["order_number_label_exist"] == "1"
      ? true
      : false;

  var keys_array = ["angle", "img_url"];

  for (var customizer_printer_settings_key in customizer_printer_settings) {
    if (
      customizer_printer_settings_key != "img_url" &&
      customizer_printer_settings.hasOwnProperty(
        customizer_printer_settings_key
      ) &&
      customizer_printer_settings_key.indexOf("order_number") < 0
    ) {
      var customizer_printer_settings_val =
        customizer_printer_settings[customizer_printer_settings_key];

      var append_key = "" == printer_query_string ? "" : "&";

      if (
        printer_order_number_label_exist &&
        !keys_array.includes(customizer_printer_settings_key)
      ) {
        if (
          customizer_printer_settings.hasOwnProperty(
            "order_number_" + customizer_printer_settings_key
          )
        ) {
          customizer_printer_settings_val +=
            "__" +
            customizer_printer_settings[
              "order_number_" + customizer_printer_settings_key
            ];
        } else {
          customizer_printer_settings_val +=
            "__" + customizer_printer_settings_val.split("__").pop();
        }
      }
      printer_query_string +=
        append_key +
        customizer_printer_settings_key +
        "=" +
        customizer_printer_settings_val;
    }
  }

  return customizer_base_url + printer_query_string;
}

function get_customizer_web_url(tag) {
  var customizer_settings = customizer_fields[tag].customizer_web;
  var query_string = "";
  for (var customizer_settings_key in customizer_settings) {
    if (customizer_settings.hasOwnProperty(customizer_settings_key)) {
      var append_key = "" == query_string ? "" : "&";

      query_string +=
        append_key +
        customizer_settings_key +
        "=" +
        encodeURIComponent(customizer_settings[customizer_settings_key]);
    }
  }

  return customizer_base_url + query_string;
}

function updateCustomizedImageTag(e = "") {
  var tag = "tag";
  var tag_suffix = "-tag";
  var params = getCustomizedParams("tag");
  var img_loader = document.getElementById("image-loader" + tag_suffix);
  var customized_img_id = document.getElementById(
    "customized-image" + tag_suffix
  );

  var s = setInterval(function () {
    var e = customized_img_id;
    e.complete && 0 !== e.naturalHeight
      ? (clearInterval(s), (img_loader.style.display = "none"))
      : (img_loader.style.display = "inline-block");
  }, 1e3);

  customized_img_id.src = params.img_url;
}
function updateCustomizedImageHandle(e = "") {
  var handle = "handle";
  var handle_suffix = "-handle";
  var params = getCustomizedParams("handle");
  console.log(params);
  var img_loader = document.getElementById("image-loader" + handle_suffix);
  var customized_img_id = document.getElementById(
    "customized-image" + handle_suffix
  );

  var s = setInterval(function () {
    var e = customized_img_id;
    e.complete && 0 !== e.naturalHeight
      ? (clearInterval(s), (img_loader.style.display = "none"))
      : (img_loader.style.display = "inline-block");
  }, 1e3);

  customized_img_id.src = params.img_url;
}

function getCustomizedParams(tag = "tag") {
  var tag = tag;
  var tag_suffix = "-" + tag;
  var customized_words = [];

  var special_char_el = document.getElementById(
    "special-char-message" + tag_suffix
  );
  var heart_ele = document.getElementById("customize-heart") + tag_suffix;
  var customized_img_id = document.getElementById(
    "customized-image" + tag_suffix
  );

  var img_loader = document.getElementById("image-loader" + tag_suffix);

  var printer_customized_url = get_customizer_printer_url(tag);
  var web_customized_url = get_customizer_web_url(tag);
  var total_fields = customizer_fields[tag].total_fields;
  var force_caps = customizer_fields[tag].force_caps;
  var printer_order_number_label_exist =
    typeof customizer_printer_settings == "object" &&
    customizer_printer_settings.hasOwnProperty("order_number_label_exist") &&
    customizer_printer_settings["order_number_label_exist"] == "1"
      ? true
      : false;

  var customizer_settings = customizer_fields[tag].customizer_web;

  var printer_final_customized_url = ""; //toDo
  var all_empty = true;
  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  var t = "";
  for (i = 1; i <= total_fields; i++) {
    var k = i - 1;
    var input_val = document.getElementById(
      "customize-text-" + i + tag_suffix
    ).value;

    if (input_val.match(regex)) {
      document.getElementById("customize-text-" + i + tag_suffix).value =
        input_val.replace(regex, "");
      special_char_el.style.display = "block";
      special_char_el.textContent =
        "Some of the characters you entered are not supported and have been removed.";
      setTimeout(function () {
        special_char_el.style.display = "none";
      }, 5000);
    }
    input_val = document.getElementById(
      "customize-text-" + i + tag_suffix
    ).value;

    if (input_val) {
      all_empty = false;
    }
    t = i == 1 ? input_val : t + "__" + input_val;
    if (force_caps == "yes") {
      customized_words[k] = input_val.toUpperCase();
      t = t.toUpperCase();
    } else if (force_lower_caps == "yes") {
      customized_words[k] = input_val.toLowerCase();
      t = t.toLowerCase();
    } else {
      customized_words[k] = input_val;
    }
  }

  if (heart_ele) {
    if (heart_ele.checked) {
      customized_words[total_fields] = heart_ele.value;
      t += "__" + heart_ele.value;
      all_empty = false;
    } else {
      customized_words[total_fields] = "";
      customized_words.pop();
    }
  }

  if (all_empty) {
    customized_img_id.src = customizer_settings.img_url;
    return;
  }

  var image_url =
    web_customized_url +
    "&words=" +
    btoa(unescape(encodeURIComponent(t.replace("__~heart~", ""))));

  if (printer_order_number_label_exist) {
    var order_label = "order_number";

    if (customizer_printer_settings.hasOwnProperty("order_number_prefix")) {
      order_label =
        customizer_printer_settings["order_number_prefix"] + order_label;
    }

    if (customizer_printer_settings.hasOwnProperty("order_number_suffix")) {
      order_label =
        order_label + customizer_printer_settings["order_number_suffix"];
    }

    var t_printer = t + "__" + order_label;
  } else {
    var t_printer = t;
  }

  t_printer = t_printer.replace("♥", "");

  console.log("t_printer", t_printer);

  printer_final_customized_url =
    printer_customized_url +
    "&words=" +
    btoa(unescape(encodeURIComponent(t_printer)));
  console.log(printer_customized_url);

  return { customized_words: customized_words, img_url: image_url };
}
var remove_tag_ele = document.getElementById("customize-tag-remove");
if(remove_tag_ele)
  remove_tag_ele.addEventListener("click", removeTagCustomization);
function removeTagCustomization(e) {
  e.preventDefault();
  document.getElementById("customize-modal-element-tag").textContent = "Edit";
  document.getElementById("customized-text-tag").textContent = "";
  var edit_block = document.getElementById("edit-customization-block-tag");
  edit_block.style["display"] = "none";
  var element = document.getElementById("customize-product-tag-block");
  element.classList.remove("tag-added");
  setTimeout(update_price_atc, 1000);
}

function saveTagCustomization() {
  var params = getCustomizedParams("tag");

  document.getElementById("customize-modal-element-tag").textContent = "Edit";
  document.getElementById("customized-text-tag").textContent =
    "Your text: " + params.customized_words.join("  ").replace("~heart~", "♥");
  var edit_block = document.getElementById("edit-customization-block-tag");
  edit_block.style["display"] = "block";
  var element = document.getElementById("customize-product-tag-block");
  element.classList.add("tag-added");
  setTimeout(update_price_atc, 1000);
}

function saveHandleCustomization() {
  var params = getCustomizedParams("handle");

  document.getElementById("customize-modal-element-handle").textContent = "Edit";
  document.getElementById("customized-text-handle").textContent =
    "Your text: " + params.customized_words.join("  ").replace("~heart~", "♥");
  var edit_block = document.getElementById("edit-customization-block-handle");
  edit_block.style["display"] = "block";
  var element = document.getElementById("customize-product-handle-block");
  element.classList.add("handle-added");
  setTimeout(update_price_atc, 1000);
}


// ── Wine Tote variant customizer wiring (Phase 2, rewritten 2026-05-18) ──
// Scope-guarded: only fires when window.variantCustomizerImages exists, which
// product-info.liquid only emits when the product has the customizer.variant_image_map
// metafield. Zero effect on other customizable products.
//
// On any variant radio change (outer color swatch OR inner-modal mirror):
//   1. Mutate customizer_settings.img_url + customizer_printer_settings.img_url
//      so the all_empty early-return in updateCustomizedImage() picks up the
//      variant background.
//   2. Regex-rewrite window.customized_url + window.printer_customized_url so
//      the keystroke-built image_url and the saveCustomization() printer URL
//      both carry the correct img_url= param.
//   3. Set #customized-image src directly (covers the case where no text is
//      typed yet — updateCustomizedImage would early-return before painting).
//   4. Click the matching .product-gallery__thumbnail using variant.featured_media.id
//      Theme's Flickity carousel handler then scrolls the main gallery to that media.
//   5. Mirror the selected state onto the inner-modal swatches.
//   6. Call updateCustomizedImage() so any typed text re-renders with the new bg.

function __vci_findVariantImages(variantKey) {
  if (!window.variantCustomizerImages) return null;
  if (window.variantCustomizerImages[variantKey]) return window.variantCustomizerImages[variantKey];
  if (variantKey && variantKey.indexOf(" / ") !== -1) {
    var __opt1 = variantKey.split(" / ")[0];
    if (window.variantCustomizerImages[__opt1]) return window.variantCustomizerImages[__opt1];
  }
  return null;
}

// Build the full variant key from ALL selected option radios/selects, in option-
// position order, joined " / " to match Shopify variant.title. Single-option
// products return just the one value ("Natural") -- so their maps keep working.
function __vci_currentVariantKey() {
  var sels = document.querySelectorAll('input.product-form__single-selector:checked, select.product-form__single-selector');
  var byPos = {};
  for (var i = 0; i < sels.length; i++) {
    var el = sels[i];
    var pos = parseInt(el.getAttribute("data-option-position") || "1", 10);
    var val = el.value;
    if (el.tagName === "SELECT" && el.options[el.selectedIndex]) val = el.options[el.selectedIndex].value;
    byPos[pos] = val;
  }
  var positions = Object.keys(byPos).map(Number).sort(function(a, b) { return a - b; });
  var parts = [];
  for (var j = 0; j < positions.length; j++) parts.push(byPos[positions[j]]);
  return parts.join(" / ");
}

function __vci_findVariantMediaId(variantKey) {
  if (!window.productShopStape || !window.productShopStape.variants) return null;
  var vs = window.productShopStape.variants;
  for (var i = 0; i < vs.length; i++) {
    if (vs[i].title === variantKey || vs[i].option1 === variantKey) {
      // Use the MEDIA id (not the image id — Shopify maintains both, and the
      // gallery thumbnails carry data-media-id, not data-image-id)
      return vs[i].featured_media ? vs[i].featured_media.id : null;
    }
  }
  return null;
}

function __vci_applyVariant(variantValue) {
  try {
    if (!variantValue) return;
    var imgs = __vci_findVariantImages(variantValue);
    if (!imgs) return;

    // 0. If the customizer modal is currently open, theme.js's variant-change chain
    //    closes it (it dispatches some kind of close-modals event). Capture the
    //    pre-swap state and restore at the end so picking a color from inside the
    //    modal doesn't kick the customer out of it.
    var modalEl = document.getElementById("modal-customize-product");
    var modalWasOpen = modalEl && modalEl.getAttribute("aria-hidden") === "false";

    // 1. Mutate the metafield-derived globals so empty-text early-return uses the right URL
    if (typeof customizer_settings === "object" && customizer_settings) {
      if (imgs.web) customizer_settings.img_url = imgs.web;
    }
    if (typeof customizer_printer_settings === "object" && customizer_printer_settings) {
      if (imgs.print) customizer_printer_settings.img_url = imgs.print;
    }

    // 2. Regex-rewrite the URL strings used to build image_url + printer_final_customized_url
    if (typeof window.customized_url === "string" && imgs.web) {
      window.customized_url = window.customized_url.replace(
        /img_url=[^&]*/g, "img_url=" + encodeURIComponent(imgs.web)
      );
    }
    if (typeof window.printer_customized_url === "string" && imgs.print) {
      window.printer_customized_url = window.printer_customized_url.replace(
        /img_url=[^&]*/g, "img_url=" + encodeURIComponent(imgs.print)
      );
    }

    // 2b. ALSO mutate window.printer_img_urls — this array is what saveCustomization()
    //     reads at Add-to-Cart time to append "&img_url=..." onto the line-item URL.
    //     Built at page load from customizer_printer_settings.img_url.split('__'). For
    //     a single-field customizer it's a 1-element array. If we don't update it here,
    //     the cart line-item property stores the ORIGINAL (page-load) print URL — orders
    //     would silently print on the wrong-color bag.
    if (typeof window.printer_img_urls !== "undefined" && Array.isArray(window.printer_img_urls) && imgs.print) {
      for (var k = 0; k < window.printer_img_urls.length; k++) {
        window.printer_img_urls[k] = imgs.print;
      }
    }

    // 2c. Swap font_color too if the variant defines one. Customer's monogram text
    //     renders in this color, so it can match the bag's pre-printed headline color
    //     (white-on-white variant, light-blue-on-light-blue variant, etc.).
    //     font_color is INCLUDED in both window.customized_url and window.printer_customized_url
    //     query strings (the build loop only excludes img_url + order_number_*), so the
    //     regex replace works on both.
    // Web preview font (web_font_color, else legacy font_color)
    var __webHex = imgs.web_font_color || imgs.font_color;
    if (__webHex) {
      __webHex = String(__webHex).replace(/^#/, "");
      if (typeof customizer_settings === "object" && customizer_settings) {
        customizer_settings.font_color = __webHex;
      }
      if (typeof window.customized_url === "string") {
        window.customized_url = window.customized_url.replace(/font_color=[^&]*/g, "font_color=" + __webHex);
      }
    }
    // Print font (print_font_color, else legacy font_color) -- INDEPENDENT of web
    var __printHex = imgs.print_font_color || imgs.font_color;
    if (__printHex) {
      __printHex = String(__printHex).replace(/^#/, "");
      if (typeof customizer_printer_settings === "object" && customizer_printer_settings) {
        customizer_printer_settings.font_color = __printHex;
      }
      if (typeof window.printer_customized_url === "string") {
        window.printer_customized_url = window.printer_customized_url.replace(/font_color=[^&]*/g, "font_color=" + __printHex);
      }
    }

    // 3. Paint modal preview directly (covers the empty-text case immediately,
    //    without waiting on updateCustomizedImage to run + early-return)
    if (imgs.web) {
      var modalImg = document.getElementById("customized-image");
      if (modalImg) modalImg.src = imgs.web;
    }

    // 4. Swap main product gallery via thumbnail click (theme uses Flickity)
    var mediaId = __vci_findVariantMediaId(variantValue);
    if (mediaId) {
      var thumb = document.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
      if (thumb && typeof thumb.click === "function") thumb.click();
    }

    // 5. Sync inner-modal swatches to reflect the active selection (per axis)
    var __colorPart = (variantValue.indexOf(" / ") !== -1) ? variantValue.split(" / ")[0] : variantValue;
    var inner = document.querySelectorAll('input[name="customizer-color-mirror"]');
    for (var i = 0; i < inner.length; i++) {
      inner[i].checked = inner[i].value === __colorPart;
    }
    if (variantValue.indexOf(" / ") !== -1) {
      var __goldPart = variantValue.split(" / ")[1];
      var goldMirror = document.querySelectorAll('input[name="customizer-gold-mirror"]');
      for (var gm = 0; gm < goldMirror.length; gm++) {
        goldMirror[gm].checked = goldMirror[gm].value === __goldPart;
      }
    }

    // 6. Re-fire updateCustomizedImage so typed-text re-renders against new bg
    if (typeof updateCustomizedImage === "function") {
      updateCustomizedImage();
    }

    // 7. Re-open the modal if it was open before the swap. The theme's variant
    //    handler chain closes it; we restore it after a short tick so any
    //    pending close logic has time to settle first.
    if (modalWasOpen && modalEl) {
      // Use double-rAF to land after the theme's close logic
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (modalEl.getAttribute("aria-hidden") === "true") {
            modalEl.setAttribute("aria-hidden", "false");
          }
          // Some themes also toggle a body class; nudge it back to open state
          if (document.body && !document.body.classList.contains("modal-open")) {
            document.body.classList.add("modal-open");
          }
        });
      });
    }
  } catch (e) {
    console.warn("[customizer] applyVariant failed:", e);
  }
}

// Bind to OUTER radio change (theme-rendered color swatches)
document.addEventListener("DOMContentLoaded", function() {
  try {
    if (!window.variantCustomizerImages) return;
    var radios = document.querySelectorAll('input.product-form__single-selector, select.product-form__single-selector');
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener("change", function() {
        __vci_applyVariant(__vci_currentVariantKey());
      });
    }
    // Also apply the variant overrides for the INITIAL (page-load) variant.
    // Without this, the default variant uses the static metafield values
    // (e.g. font_color=000000) instead of the variant_image_map values
    // (e.g. font_color=F0F0F0 for White). User would have to click away
    // and back to apply White's true font color.
    var initial = document.querySelector('input.product-form__single-selector[data-option-position="1"]:checked');
    var initialKey = __vci_currentVariantKey();
    if (initialKey) {
      __vci_applyVariant(initialKey);
      // Phase 3 defensive sync (2026-05-19): when landing via ?variant=<id> URL on
      // a multi-variant product whose URL variant is `available:false`, Liquid
      // honors the URL in `option.selected_value` (radio renders correctly) but
      // `product.selected_or_first_available_variant` falls back to the first
      // variant — so the cart <select name="id"> and product JSON ship with the
      // wrong variant_id. If user adds to cart without clicking a swatch, they
      // get the wrong variant. Forcing a change event on the initial radio
      // re-runs theme.js _onOptionChanged, which syncs the cart select + URL +
      // visible label to match the radio. Idempotent when state already agrees.
      try { initial.dispatchEvent(new Event("change", {bubbles: true})); } catch (e2) {}
    }
  } catch (e) {
    console.warn("[customizer] outer listener bind failed:", e);
  }
});

// Exposed for inner-modal swatch script — triggers the outer radio's change,
// which is what fires __vci_applyVariant via the listener above.
window.__vciTriggerOptionChange = function(position, value) {
  try {
    var radios = document.querySelectorAll('input.product-form__single-selector[data-option-position="' + position + '"]');
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].value === value) {
        radios[j].checked = true;
        radios[j].dispatchEvent(new Event("change", {bubbles: true}));
        return true;
      }
    }
  } catch (e) {
    console.warn("[customizer] triggerOptionChange failed:", e);
  }
  return false;
};

// Back-compat wrapper -- existing inner color-swatch script calls this with a Color value.
window.__vciTriggerVariantChange = function(variantValue) {
  return window.__vciTriggerOptionChange(1, variantValue);
};
